import { PartType } from 'lit/directive.js';
import { FunctionalElementBaseClass } from '../functional-element';
export function extractFunctionalElement(partInfo, directiveName) {
    return extractElement(partInfo, directiveName, FunctionalElementBaseClass);
}
export function extractElement(partInfo, directiveName, constructorClass) {
    assertsIsElementPartInfo(partInfo, directiveName);
    const element = partInfo.element;
    if (!(element instanceof constructorClass)) {
        throw new Error(`${directiveName} attached to non ${constructorClass.name} element.`);
    }
    return element;
}
export function assertsIsElementPartInfo(partInfo, directiveName) {
    if (partInfo.type !== PartType.ELEMENT) {
        throw new Error(`${directiveName} directive can only be attached directly to an element.`);
    }
    if (!partInfo.element) {
        throw new Error(`${directiveName} directive found no element`);
    }
}
